module.exports = __webpack_public_path__ + "static/BrandonGrotesque-ExtraBoldItalic-05cd87b0db8139f072502631ce346617.woff";